import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import AnnouncementsCreateEditForm from './Components/AnnouncementsCreateEditForm';
import AnnouncementsApi from './AnnouncementsApi';
import moment from 'moment';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: AnnouncementsCreateEditForm,
                getCreate: AnnouncementsApi.create,
                defaults: { expireOn: moment().add(14, 'days').toJSON() },
                successMessage: "Announcements Saved",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}